import './ConfigureSearchScreen.scss';

import React, { useEffect, useState } from 'react';

import { useSelector, useDispatch } from 'react-redux';

import { Helmet } from 'react-helmet';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { InputLabel, Select, MenuItem, FormControl } from '@mui/material';
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import Button from 'src/component/UI/Button';
import RowComponent from './RowComponent';

import { fetchConfiguredSearchFields, fetchAllSearchableFields, updateConfiguredSearchFields } from 'src/module/search/action';
import { getConfiguredSearchFields, getAllSearchableFields } from 'src/module/search/selector';
import { isWhitelabel } from 'src/utils/utils';
import { useTranslation } from 'src/i18n';

export default function ConfigureSearchScreen () {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const allSearchableFields = useSelector(getAllSearchableFields);
  const configuredSearchFields = useSelector(getConfiguredSearchFields);

  const [selectedOption, setSelectedOption] = useState('');
  const [rows, setRows] = useState([]);

  const tableLookup = {
    'devices': t('search.devices')
  };

  useEffect(() => {
    dispatch(fetchAllSearchableFields('devices'));
    dispatch(fetchConfiguredSearchFields('devices'));
  }, []);

  const updateLabel = (e) => {
    setSelectedOption(e.target.value);
  };

  const addFieldToSearch = (rec) => {
    const table = rec?.get('table_name');
    const field = rec.get('field_name');
    let updatedFields;
    configuredSearchFields.data?.map((values) => {
      updatedFields = values.push(field);
    });
    dispatch(updateConfiguredSearchFields(table, updatedFields));
    setSelectedOption('');
  };

  const handleDeleteSearchField = (table, field) => {
    let updatedFields;
    configuredSearchFields.data?.map((values) => {
      updatedFields = values.filter(val => val !== field);
    });
    dispatch(updateConfiguredSearchFields(table, updatedFields));
  };

  useEffect(() => {
    configuredSearchFields?.data?.map(fields => {
      const tempArray = [];
      fields.map(field => {
        tempArray.push({ field });
      });
      setRows(tempArray);
    });
  }, [configuredSearchFields?.data]);


  const handleDragEnd = (result, table) => {
    if (!result.destination) return;

    const updatedRows = Array.from(rows);
    const [reorderedItem] = updatedRows.splice(result.source.index, 1);
    updatedRows.splice(result.destination.index, 0, reorderedItem);
    setRows(updatedRows);

    // update ranking of fields
    const sortedFields = [];
    updatedRows?.map(row => {
      sortedFields.push(row.field);
    });
    dispatch(updateConfiguredSearchFields(table, sortedFields));
  };

  const title = isWhitelabel() ? 'ATCOM' : 'SmartTrace';

  return (
    <div className='page' id='configure-search-screen' data-testid='configure-search-screen'>
      <Helmet>
        <title>{title} - {t('search.configureSearch')}</title>
      </Helmet>
      <h2>{t('search.configureSearch')}</h2>

      <Grid container spacing={3}>
        {configuredSearchFields?.data?.reduce((acc, values, key) => {
          acc.push(
            <Grid item md={6} key={key}>
              <Paper>
                <h3>{t('search.fieldsIncludedIn', { table: tableLookup[key] })}</h3>
                <DragDropContext onDragEnd={(e) => handleDragEnd(e, key)}>
                  <Droppable droppableId="rows">
                    {(provided) => (
                      <div {...provided.droppableProps} ref={provided.innerRef}>
                        {
                          rows.length > 0 ? rows.map((row, index) => (
                            <RowComponent key={row.field} row={row} table={key} index={index} handleDeleteSearchField={handleDeleteSearchField}/>
                          )) :
                            <p className='no-data-in-table'>{t('search.noFieldsAdded')}</p>

                        }
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>

                <br/>
                <h3>{t('search.addMoreFieldsTo', { table: tableLookup[key] })}</h3>
                <FormControl className='add-search-field-form'>
                  <InputLabel>
                    {t('search.addField')}
                  </InputLabel>
                  <div>
                    <Select
                      value={selectedOption}
                      variant="standard"
                      autoWidth={true}
                      sx={{ width: '200px', marginRight: '30px' }}
                      onChange={updateLabel}
                      MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                    >
                      {allSearchableFields.filter(allFields => !values.includes(allFields.get('field_name'))).map(field => (
                        <MenuItem key={field} value={field}>{t(field.get('field_name'))}</MenuItem>
                      ))}
                    </Select>
                    <Button onClick={() => addFieldToSearch(selectedOption)} disabled={selectedOption === ''} cta>{t('common.save')}</Button>
                  </div>
                </FormControl>
              </Paper>
            </Grid>
          );
          return acc;
        }, [])}
      </Grid>
    </div>
  );
}
